"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuSelectMultipleAvailable = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ActionMenuSelectMultipleAvailable = styled_components_1.default.select `
  min-width: 250px;
  min-height: 250px;
  margin-top: 5px;
  margin-bottom: 5px;
`;
//# sourceMappingURL=action-menu-select-multiple-available.js.map